import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { getIntlLocale } from "util/locale";
import { useTranslation } from "react-i18next";
import { UNLOGGED } from "util/constants";
import Representation from "./Representation";

const EngagementPage = ({ authenticated, user, theme = "dark" }) => {
  const history = useHistory();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (authenticated === UNLOGGED) {
      history.push("/");
    }
  }, [authenticated, history]);

  const locale = getIntlLocale(i18n.language);

  return <Representation user={user} locale={locale} theme={theme} />;
};

export default EngagementPage;
